// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1N9pl","left":"InfoRow_left__1e15P"};